import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Table from '../../сomponents/Table';
import Breadcrumbs from '../../common/Breadcrumbs';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';

import { fetchShops, removeShopById } from '../../api/shops';
import './style.css';
import Preloader from "../../common/Preloader";
import hasAccess from "../../helpers/permissionChecker";

export class Shops extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.addShop = this.addShop.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      loading: true,
      currentPage: 0,
    };

    this.columns = [
      'name',
      'created',
    ];

    this.columnNames = [
      'Name',
      'Date Created',
    ];
  }

  addShop() {
    this.props.moveToAdd();
  }

  componentDidUpdate() {
    const { loading } = this.state;
    const shopList = path(['shops', 'list'], this.props);
    if (loading && shopList) {
      this.setState({ loading: false });
    }
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  componentWillMount() {
    this.props.loadShops();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: removeShopById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'removeShopById',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  render() {
    const shopList = path(['shops', 'list'], this.props);
    const { loading } = this.state;
    const itemActions = {
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },

      delete: {
        handler: this.handlerDelete,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        authorColumnName: 'owner_id',
        permission: { 'permAreaKey': 'shops', 'permTypeKey': 'delete' },
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };
    const mainPart = loading ? <Preloader show={true} type='circle'/> :
      <Table
        items={shopList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        actions={itemActions}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />;
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'shop', name: 'Shops' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            Shops
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'shops', 'permTypeKey': 'create' }) &&
            <div className="clearfix mb-3">
              <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addShop}>
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add</span>
              </button>
            </div>
            }

            {mainPart}
            <ConfirmAction id={'removeShopById'}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadShops: () => fetchShops()(dispatch),

    moveToEdit: (id) => {
      dispatch(push('/pages/edit-shop/' + id));
    },
    moveToDelete: () => {
      dispatch(push('/pages/delete-shops'));
    },
    moveToAdd: () => {
      // Move to pages
      dispatch(push('/pages/add-shop'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Shops);



// WEBPACK FOOTER //
// ./src/containers/Shops/index.js